export const excelColor = "#007A33";
export const pdfColor = "#D32F2F";
export const primary = "#FC8019";
export const lightPrimary = "#fff2e8";
export const lightGrey = "#f8f9fa";
export const blue = "#0d6efd";
export const secondary = "#6c757d";
export const success = "#198754";
export const danger = "#dc3545";
export const warning = "#ffc107";
export const info = "#0dcaf0";
export const light = "#f8f9fa";
export const dark = "#212529";

export const white = "#ffffff";
export const gray100 = "#f8f9fa";
export const gray200 = "#e9ecef";
export const gray300 = "#dee2e6";
export const gray400 = "#ced4da";
export const gray500 = "#adb5bd";
export const gray600 = "#6c757d";
export const gray700 = "#495057";
export const gray800 = "#343a40";
export const gray900 = "#212529";
export const black = "#000000";
